import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const createAssignment = async (data) => {
  const res = await axiosInstance.post("/teacher-subjects/create", data);
  return res.data;
};

export const getAllAssignments = async (filters = {}) => {
  const res = await axiosInstance.get("/teacher-subjects/all", { params: filters });
  return res.data;
};

export const getTeacherSubjects = async (staffId) => {
  const res = await axiosInstance.get(`/teacher-subjects/teacher/${staffId}`);
  return res.data;
};

export const getSectionSubjects = async (sectionId) => {
  const res = await axiosInstance.get(`/teacher-subjects/section/${sectionId}`);
  return res.data;
};

export const updateAssignment = async (id, data) => {
  const res = await axiosInstance.put(`/teacher-subjects/update/${id}`, data);
  return res.data;
};

export const deleteAssignment = async (id) => {
  const res = await axiosInstance.delete(`/teacher-subjects/delete/${id}`);
  return res.data;
};